import React from 'react';
import Input from 'reactstrap/lib/Input';
import Label from 'reactstrap/lib/Label';
import styles from './index.module.scss';
import { FormatDateString, ValueOnly, handleKeyPress } from './util';
import { DayDateFieldProps } from './types';

const { dayWidth, spanDateInput } = styles;

export const DayFieldInput = (props: DayDateFieldProps) => {
    const { value, onChangeHandler, hasDayPart, onBlur, id } = props;

    if (!hasDayPart) {
        return null;
    }

    const activeId = document.activeElement === null ? 'unknown' : document.activeElement.id;

    const hasFocus = id === activeId;
    const displayValue = !value ? '' : hasFocus ? value : FormatDateString(value, 2);

    const onFocus = (event: React.FocusEvent<any>) => {
        event.currentTarget.value = ValueOnly(event.currentTarget.value);
        event.currentTarget.select();
    };

    return (
        <span className={spanDateInput} >
            <Label htmlFor={id} className='rdtiSubQuestion'>Day<span className='sr-only'>(DD)</span></Label>
            <Input
                id={id}
                className={dayWidth}
                type='text'
                autoComplete='off'
                onFocus={onFocus}
                onChange={onChangeHandler}
                value={displayValue} // turn 0 and undefined to ''
                onBlur={onBlur}
                onKeyPress={handleKeyPress}
                placeholder='DD'
            />
        </span>
    );
};
